import React, { FC } from "react";
import { useQuery } from "react-query";
import { IStatisticsFilter } from "../types";
import useStatisticsQueries from "../hooks/useStatisticsQueries";
import { parseToEducationTypesStatisticsModel } from "../helpers/helperFunctions";
import { IPieChartSegment } from "../../../components/PieChart/types";
import PieChartWidget from "../../../components/PieChart";

interface IEducationTypeWidgetProps {
  filter: IStatisticsFilter;
}

export const EducationTypeWidget: FC<IEducationTypeWidgetProps> = ({
  filter,
}) => {
  const { fetchByEducationType } = useStatisticsQueries();

  const { isLoading, data } = useQuery<IPieChartSegment[]>(
    `educationTypeStatistics${JSON.stringify(filter)}`,
    async () => {
      const data = await fetchByEducationType(filter);
      return parseToEducationTypesStatisticsModel(data.data);
    },
  );

  return (
    <PieChartWidget
      isLoading={isLoading}
      data={data || []}
      title="Distribution by education types"
    />
  );
};
